<template>
  <v-container
    class="trades-view-container"
    fluid
  >
    <h1>Trades</h1>
    <trades-table
      :trades="trades"
      :trades-pagination="tradesPagination"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toQueryString } from '@/helpers';

import { TradesTable } from '@/components/trades';

export default {
  name: 'Trades',
  components: {
    'trades-table': TradesTable,
  },
  computed: {
    ...mapState({
      loading: state => state.tradesStore.loading,
      trades: state => state.tradesStore.trades,
      tradesPagination: state => state.tradesStore.tradesPagination,
    }),
  },
  async mounted() {
    this.getTrades(toQueryString({ sort: 'created_at', dir: 'desc', page: 1, limit: 25 }));
  },
  methods: {
    ...mapActions(['getTrades']),
  },
};
</script>


<style lang="scss" scoped>
.trades-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/trades/Trades.vue